module.exports = __webpack_public_path__ + "03_medium_black.48473afd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/03_medium_black.png
// module id = t2ZR
// module chunks = 0